import type { AirdropCampaignAllocationsDataset } from '@infinex/types';

import type { AirdropCampaignAllocationsFilters } from '../../types';

/**
 * Filters airdrop campaign allocations based on provided criteria.
 */
export function filterAirdropCampaignAllocations(
  dataset: AirdropCampaignAllocationsDataset,
  filters?: AirdropCampaignAllocationsFilters
): AirdropCampaignAllocationsDataset {
  // If no filters provided, return the full dataset
  if (
    !filters ||
    (!filters.campaignId &&
      !filters.campaignKey &&
      !filters.claimStatus &&
      filters.isClaimable === undefined)
  ) {
    return dataset;
  }

  const filtered = dataset.airdropCampaignAllocations.flatMap(
    (campaignAllocation) => {
      // Filter by campaignId
      if (
        filters.campaignId &&
        campaignAllocation.campaign.id !== filters.campaignId
      ) {
        return [];
      }

      // Filter by campaignKey
      if (
        filters.campaignKey &&
        campaignAllocation.campaign.key !== filters.campaignKey
      ) {
        return [];
      }

      // Filter by claimStatus
      if (filters.claimStatus && filters.claimStatus.length > 0) {
        const hasMatchingStatus = [
          ...campaignAllocation.claimedAllocationSets,
          ...campaignAllocation.unclaimedAllocationSets,
        ].some((set) => filters.claimStatus?.includes(set.claimStatus));

        if (!hasMatchingStatus) {
          return [];
        }

        return [
          {
            ...campaignAllocation,
            claimedAllocationSets:
              campaignAllocation.claimedAllocationSets.filter((set) =>
                filters.claimStatus?.includes(set.claimStatus)
              ),
            unclaimedAllocationSets:
              campaignAllocation.unclaimedAllocationSets.filter((set) =>
                filters.claimStatus?.includes(set.claimStatus)
              ),
          },
        ];
      }

      // Filter by isClaimable
      // TODO: Change this to be based on the allocation itself
      if (typeof filters.isClaimable === 'boolean') {
        const isClaimable = campaignAllocation.unclaimedAllocationSets.some(
          (set) => set.isClaimable
        );
        if (isClaimable !== filters.isClaimable) {
          return [];
        }
      }

      return [campaignAllocation];
    }
  );

  return {
    airdropCampaignAllocations: filtered,
  };
}
